var options = window.themeVariables.optionsLSP;
var lang = window.themeVariables.langLSP;
var lspSheetStorageVersion = "lspDataSheet-v" + options.sheetStorageVersion;

csvFetchLSP();
async function csvFetchLSP() {
            //Rely on shop switch for location
            function getIpCountryCode() {
                const maxAttempts = 4;
                const delayBetweenAttempts = 500; // 500ms delay
            
                return new Promise((resolve, reject) => {
                    const attemptRequest = (attempt) => {
                        try {
                            const locationDataLocalStorage = JSON.parse(localStorage.getItem('geodata'));
                            const shopSwitchIpLocation = locationDataLocalStorage.country_code;
                            resolve(shopSwitchIpLocation);
                        } catch (error) {
                            if (attempt === maxAttempts) {
                                // If it's the last attempt, try fetching the response from the new API
                                var url = "https://api.ipstack.com/check?access_key=" + options.ipstackAPIKey;
                                fetch(url)
                                    .then(response => {
                                        if (!response.ok) throw new Error("Failed to fetch");
                                        return response.json();
                                    })
                                    .then(data => {
                                        window.ipstack = data;
                                        localStorage.setItem('geodata', JSON.stringify(window.ipstack));
                                        resolve(window.ipstack.country_code);
                                    })
                                    .catch(() => {
                                        // If the API call fails, resolve with "DEFAULT"
                                        resolve("DEFAULT");
                                    });
                            } else {
                                // Make the next attempt after the delay
                                setTimeout(() => {
                                    attemptRequest(attempt + 1);
                                }, delayBetweenAttempts);
                            }
                        }
                    };
            
                    // Start the first attempt
                    attemptRequest(1);
                });
            }
            //Getting local stored LSP data
            function lspStoredDataGet() {
                return new Promise(resolve => {
                    resolve(JSON.parse(localStorage.getItem(lspSheetStorageVersion)));
                });
            }
            var lspStoredData = await lspStoredDataGet();
            var locationData = await getIpCountryCode();
            //Set to false for local storage debugging
            //var lspStoredData = false;
            if(lspStoredData) {
                var data = lspStoredData;
                console.log('has local data');
                getCountryData(locationData,data);  
            } else if (locationData) {
                console.log('get new data');
                const sheetURL = options.sheetUrl;
                const sheetName = options.sheetName;
                const sheetAPIKey = options.sheetAPIKey;
                console.log('test 1');
                if (sheetURL && sheetName && sheetAPIKey) {
                    const fetchUrl = 'https://sheets.googleapis.com/v4/spreadsheets/' +
                            options.sheetUrl + '/values/' + options.sheetName +
                            '?alt=json&key=' + options.sheetAPIKey;
                    $.ajax({url: fetchUrl, type: 'GET', dataType: 'json'})
                    .done(function(data) {
                        console.log('got data');
                        console.log(data);
                        // Start render when we have response from Sheets
                        if (locationData && data) {
                            getCountryData(locationData,data);  
                            localStorage.setItem(lspSheetStorageVersion, JSON.stringify(data));

                            // Array for old local storage LSPs
                            var lspOldStorageArr = []; 
                        
                            // Iterate over localStorage and insert the keys that meet the condition into lspOldStorageArr
                            for (var i = 0; i < localStorage.length; i++){
                                const lspStorageInstance = localStorage.key(i).split('DataSheet-v');
                                const lspStorageInstancePrefix = lspStorageInstance.shift();
                                if (localStorage.key(i) === lspSheetStorageVersion) {
                                    //Keep newest local storage
                                } else if (lspStorageInstancePrefix === 'lsp') {
                                    lspOldStorageArr.push(localStorage.key(i));
                                }
                            }
                        
                            // Iterate over lspOldStorageArr and remove the items by key
                            for (var i = 0; i < lspOldStorageArr.length; i++) {
                                localStorage.removeItem(lspOldStorageArr[i]);
                            }
                        }
                    })
                    .fail((e) => console.log(e.status));
                }
            }
};



        
      // Rendering and prettying data
      var renderDataLSP = function (currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText) {
        // Constructing data for display

        showShippingInfo(currentCountryActiveData);
        showCountrySelector(currentCountryActiveData);

        //Get cart on page load and taking action
        $.getJSON('/cart.js', function (cart) {
            var currentCart = cart;
            insertUSPData(currentCart,currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText);
            updateShippingProgress(currentCart,currentCountryActiveData,currentCountryActiveUspData);
        })

        //updating cart drawer based on cart elements - cart JSON cart not needed
        updateCartPriceAndShipping(currentCountryActiveData,currentCountryActiveUspData);

        //Listener to cart action
        startCurrentCartListener(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText);
        
      }


     function insertUSPData(currentCart,currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText) {
        let currentCountryShippingPrice = "";
        let currentCountryDeliveryTime = "";
        let currentCountryFreeShippingThreshold = "";
        var minOrderAmount = "";
        var currentCountryName = "";

        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyShippingProduct = false;
        let isHeavyDeliveryTimeProduct = false;
        let isHeavyThresholdProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.DeliveryTimeHeavy) {
                isHeavyDeliveryTimeProduct = true;
            } 
            if(currentCountryActiveData.ShippingPriceHeavy) {
                isHeavyShippingProduct = true;
            } 
            if(currentCountryActiveData.FreeShippingThresholdHeavy) {
                isHeavyThresholdProduct = true;
            } 
        }
        //heavy product in cart
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyDeliveryTimeProduct = true;
            isHeavyShippingProduct = true;
            isHeavyThresholdProduct = true;
        }
        currentCountryDeliveryTime = isHeavyDeliveryTimeProduct ? currentCountryActiveData.DeliveryTimeHeavy:currentCountryActiveData.DeliveryTime;
        currentCountryShippingPrice = isHeavyShippingProduct ? currentCountryActiveData.ShippingPriceHeavy:currentCountryActiveData.ShippingPrice;
        currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;
        if(currentCountryFreeShippingThreshold) {
            currentCountryFreeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
        }

        //Delivery time with days
        if (currentCountryDeliveryTime) {
            currentCountryDeliveryTime = currentCountryDeliveryTime + " " + lang.days;
        }
        //FreeShippingThreshold = minimum order amount
        if(currentCountryFreeShippingThreshold) {
            minOrderAmount = slateCurrency.formatMoney(currentCountryFreeShippingThreshold * 100, window.themeVariables.settings.moneyFormat, true);
        }
        //Active country name
        if (currentCountryActiveData.Country) {
            currentCountryName = currentCountryActiveData.Country
        }
        //Active shipping price
        if (currentCountryShippingPrice) {
            currentCountryShippingPrice = slateCurrency.formatMoney(currentCountryShippingPrice * 100, window.themeVariables.settings.moneyFormat);
        }

        
        $( ".lspList .lspListInner" ).each(function( index ) {
            var allUspMessageContent = "";
            //Make blank if threshhold is 0/heavy
            if(isHeavyShippingProduct && uspFallbackTextData) {
                const ArrayHasFallbackUSP = currentCountryActiveUspData.find(currentCountryActiveUspData =>currentCountryActiveUspData.includes(uspFallbackTextData));
                if(ArrayHasFallbackUSP) {

                } else {
                currentCountryActiveUspData.push(uspFallbackTextData);
                }
            }
            var isCartList = $(this).closest('.lspListCart').length > 0;
            var uspDataToRender = currentCountryActiveUspData;
            if (isCartList) {
                uspDataToRender = [];
                if (forcedCartUspText) {
                    //Force the lock icon (usp_icon_5) on the forced cart USP regardless of the sheet shortcode
                    var forcedCartUspItem = forcedCartUspText;
                    if (/\[icon\d+\]/.test(forcedCartUspItem)) {
                        forcedCartUspItem = forcedCartUspItem.replace(/\[icon\d+\]/, "[icon5]");
                    } else {
                        forcedCartUspItem = "[icon5]" + forcedCartUspItem;
                    }
                    uspDataToRender.push(forcedCartUspItem);
                }
                uspDataToRender = uspDataToRender.concat(
                    currentCountryActiveUspData.filter(function(t) { return t !== forcedCartUspText; }).slice(0, 3)
                );
            }
            for (var uspCount = 0; uspCount < uspDataToRender.length; uspCount++) {  
                //Replacing amount with min order amount
                let formatedCurrentCountryActiveUspData = uspDataToRender[uspCount];
                if(formatedCurrentCountryActiveUspData) {
                    let isFallBackUSP = false; 
                    if(formatedCurrentCountryActiveUspData === uspFallbackTextData) {
                        isFallBackUSP = true; 
                    }
                    //Make blank if threshhold is 0/heavy
                    if(currentCountryFreeShippingThreshold === 0 && !isFallBackUSP) {
                        if(formatedCurrentCountryActiveUspData.includes("[amount]") || formatedCurrentCountryActiveUspData.includes("[time]")) {
                            formatedCurrentCountryActiveUspData = "";
                        }
                    } else if (isHeavyShippingProduct && isFallBackUSP){

                        //Insure USP with amount don't show up
                        if(currentCountryFreeShippingThreshold === 0) {
                            if(formatedCurrentCountryActiveUspData.includes("[amount]")) {
                                formatedCurrentCountryActiveUspData = "";
                            }
                        }
                    } 


                    //Insure USP with hide-heavy gets excluded
                    if(isHeavyDeliveryTimeProduct && formatedCurrentCountryActiveUspData.includes("[hide-heavy]")) {
                        formatedCurrentCountryActiveUspData = "";
                    }
                    //FORMATING shortcodes

                    //Feature to come - shipping price
                    /*
                    if (formatedCurrentCountryActiveUspData.includes("[price]") && minOrderAmount ) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[price]", minOrderAmount);
                    }
                    */

                    //Replacing amount with min amount for deliver
                    if (formatedCurrentCountryActiveUspData.includes("[amount]") && minOrderAmount ) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[amount]", minOrderAmount);
                    }

                    //Replacing time with delivery days
                    if (formatedCurrentCountryActiveUspData.includes("[time]") && currentCountryDeliveryTime) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[time]", currentCountryDeliveryTime);
                    }

                    //Replacing country with country name
                    if (formatedCurrentCountryActiveUspData.includes("[country]") && currentCountryName) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[country]", currentCountryName);
                    }

                    //Replacing hide-heavy shortcode
                    if (formatedCurrentCountryActiveUspData.includes("[hide-heavy]") && currentCountryName) {
                        formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace("[hide-heavy]", "");
                    }

                    //Replacing icon with icon from Shopify settings
                    var iconCount = "";
                    if (formatedCurrentCountryActiveUspData.includes("[icon")) {
                        iconCount = uspDataToRender[uspCount].split('[icon')
                        .filter(function(v){ return v.indexOf(']') > -1})
                        .map( function(value) { 
                            iconCount = value.split(']')[0]
                            const currentUspIcon = "usp_icon_" + iconCount;
                            iconShortcode = "[icon" + iconCount + "]";
                            if (currentCountryActiveData.USPIcons && currentCountryActiveData.USPIcons[currentUspIcon]) {
                                formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace(iconShortcode, '<span class="ProductCountryUsp__Icon">' + currentCountryActiveData.USPIcons[currentUspIcon] + '</span><span class="ProductCountryUsp__Text">');
                            } else {
                                formatedCurrentCountryActiveUspData = formatedCurrentCountryActiveUspData.replace(iconShortcode, '<span class="ProductCountryUsp__Text">');
                            }
                        })
                    }
                        allUspMessageContent = allUspMessageContent + '<div class="lspListItem">' + formatedCurrentCountryActiveUspData + '</div>';
                }
                if(currentCountryActiveData.EnabledCountry === "TRUE") {
                    $(this).parent().removeClass("skeletonHidden");
                    $(this).parent().addClass("skeletonShow");
                }
            }
            //HTML rendering
            $(this).html(allUspMessageContent);
        });
        // Update [amount] and [country] in LSP-Banner banners after DOM update
        updateLSPBannerAmounts(minOrderAmount, currentCountryName);
    }
    function showCountrySelector(currentCountryActiveData) {
        //Active country name
        var currentCountryName = "";
        if (currentCountryActiveData.Country) {
            currentCountryName = currentCountryActiveData.Country
        }
        $( ".lspCountrySelect" ).each(function( index ) {
            $(this)[0].innerHTML = currentCountryName;
        });
    }
    function showShippingInfo(currentCountryActiveData) {
        console.log('here');
        console.log(currentCountryActiveData);
        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyDeliveryTimeProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.DeliveryTimeHeavy) {
                isHeavyDeliveryTimeProduct = true;
            } 
        }
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyDeliveryTimeProduct = true;
        }
        let currentCountryDeliveryTime = isHeavyDeliveryTimeProduct ? currentCountryActiveData.DeliveryTimeHeavy:currentCountryActiveData.DeliveryTime;

        //Delivery time with days
        if (currentCountryDeliveryTime) {
            currentCountryDeliveryTime = currentCountryDeliveryTime + " " + lang.days;
        }
        $( ".lspShippingInfo" ).each(function( index ) {
            let deliveryTimeEl = $(this).find('.lspExpectedDeliveryTime')[0];
            if(deliveryTimeEl && currentCountryDeliveryTime) {
                deliveryTimeEl.innerHTML = currentCountryDeliveryTime;
                if(currentCountryActiveData.EnabledCountry === "TRUE") {
                    $(this).removeClass("skeletonHidden");
                    $(this).addClass("skeletonShow");
                }
            }

        });
    }
    function updateCartPriceAndShipping(currentCountryActiveData) {
        function applyCartTotals() {
            let currentCountryShippingPrice = "";
            let currentCountryShippingPriceRaw = "";
            let currentCountryFreeShippingThreshold = "";

            let hasHeavyWeightCartItem = false;
            let isHeavyThresholdProduct = false;
            if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
                hasHeavyWeightCartItem = true;
                isHeavyThresholdProduct = true;
            }
            currentCountryShippingPriceRaw = hasHeavyWeightCartItem ? currentCountryActiveData.ShippingPriceHeavy:currentCountryActiveData.ShippingPrice;

            if (currentCountryShippingPriceRaw) {
                currentCountryShippingPrice = slateCurrency.formatMoney(currentCountryShippingPriceRaw * 100, window.themeVariables.settings.moneyFormat);
            }

            //Use heavy Shipping Delivery time and shipping data if heavy product
            currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;

            $( ".CartTotalLSP" ).each(function( index ) {
                var currentCountryName = "";
                //Active country name
                if (currentCountryActiveData.Country) {
                    currentCountryName = currentCountryActiveData.Country
                }
                let cartShippingPriceEl = $(this).find('.Cart__ShippingPrice');
                let cartShippingPriceTitleEl = $(this).find('.Cart__Shipping [data-shipping-title]')[0];
                if(cartShippingPriceTitleEl) {
                    let cartShippingPriceTitle = cartShippingPriceTitleEl.innerHTML;
                    if(cartShippingPriceTitleEl && cartShippingPriceTitle.includes("[country]") && currentCountryName) {
                        cartShippingPriceTitle = cartShippingPriceTitle.replace("[country]", currentCountryName);
                        cartShippingPriceTitleEl.innerHTML = cartShippingPriceTitle;
                    }
                }
                const cartTotalPriceValue = $(this).find('.Cart__TotalPrice').attr('data-cart-total-price');
                const cartGrandTotalEl = $(this).find('.Cart__GrandTotalPrice');

                //Free shipping progress
                var freeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
                var hasFreeShippingThreshold = (!isNaN(freeShippingThreshold) && freeShippingThreshold > 0);
                var currentProgress = 0;
                if(hasFreeShippingThreshold && Number(cartTotalPriceValue)) {
                    var thresholdInCents = freeShippingThreshold * 100;
                    currentProgress = (Number(cartTotalPriceValue) / thresholdInCents) * 100;
                    if(Number(cartTotalPriceValue) == 0) {
                        currentProgress = 0;
                    } else if (currentProgress >= 100) {
                        currentProgress = 100;
                    }
                }

                var shippingIsFree = hasFreeShippingThreshold && currentProgress >= 100;
                var cartTotalCents = Number(cartTotalPriceValue) || 0;
                var shippingCents = currentCountryShippingPriceRaw ? Number(currentCountryShippingPriceRaw) * 100 : 0;

                //Shipping (Fragt) line
                if (cartShippingPriceEl && cartShippingPriceEl.length) {
                    if (shippingIsFree) {
                        cartShippingPriceEl.html(lang.freeShippingShort);
                    } else if (currentCountryShippingPrice) {
                        cartShippingPriceEl.html(currentCountryShippingPrice);
                    }
                }

                //Grand total = cart subtotal + shipping (when charged)
                if (cartGrandTotalEl && cartGrandTotalEl.length && cartTotalPriceValue) {
                    var grandTotalCents = cartTotalCents + (shippingIsFree ? 0 : shippingCents);
                    cartGrandTotalEl.html(slateCurrency.formatMoney(grandTotalCents, window.themeVariables.settings.moneyFormat));
                }

                if(currentCountryActiveData.EnabledCountry === "TRUE") {
                    $(this).find('.Cart__Shipping').removeClass("skeletonHidden").addClass("skeletonShow");
                    $(this).find('.Cart__GrandTotal').removeClass("skeletonHidden").addClass("skeletonShow");
                }
            });
        }

        //Run immediately on load so Fragt/Total show without interaction
        applyCartTotals();
        //Re-run when the cart drawer refreshes after a cart change
        document.addEventListener('cart-drawer:refreshed', applyCartTotals);
        //Re-run on any cart action (add/update/change/clear)
        window.addEventListener('SCE:action', applyCartTotals);
    }


    function updateShippingProgress(currentCart,currentCountryActiveData) {
        let currentCountryFreeShippingThreshold = "";

        //Use heavy Shipping Delivery time and shipping data if heavy product
        let isHeavyThresholdProduct = false;
        if(options.productIsHeavyWeight) {
            if(currentCountryActiveData.FreeShippingThresholdHeavy) {
                isHeavyThresholdProduct = true;
            } 
        }
        //heavy product in cart
        if(document.querySelectorAll('[data-lsp-heavy-weight-item]')[0]) {
            isHeavyThresholdProduct = true;
        }
        currentCountryFreeShippingThreshold = isHeavyThresholdProduct ? currentCountryActiveData.FreeShippingThresholdHeavy:currentCountryActiveData.FreeShippingThreshold;

        var freeShippingThreshold = parseInt(currentCountryFreeShippingThreshold);
        if(freeShippingThreshold !== "" && currentCart.total_price !== "") {
                var remainingAmount = (currentCart.total_price / 100) - freeShippingThreshold;
                var remainingAmountFormat = slateCurrency.formatMoney(remainingAmount * -1 * 100, window.themeVariables.settings.moneyFormat);
                
                //Calculating percentage progress of free shipping
                var thresholdInCents = freeShippingThreshold * 100;
                var cartThresholdDifference = (currentCart.total_price / thresholdInCents) * 100;
                var currentProgress = 0;
                currentProgress = cartThresholdDifference;
                if(currentCart.total_price == 0) {
                    currentProgress = 0;
                } else if (currentProgress >= 100) {
                    currentProgress = 100;
                }
                let progressAboveMinCartTotal = true;
                if (options.progressMinCartTotal) {
                    let progressMinCartTotal = options.progressMinCartTotal * 100;
                    if(currentCart.total_price < progressMinCartTotal) {
                        progressAboveMinCartTotal = false;
                    }
                }   
                currentProgressWithPercentage = currentProgress + "%";
                //Applying progress to bar
                if(progressAboveMinCartTotal) {
                    $( ".ProgressLSP" ).each(function( index ) {
                        const progressBarElWrapper = $(this);
                        const progressBarEl = $(this).find('.ProgressBar__Active');
                        const progressBarShowing = progressBarEl.hasClass("ProgressLSPShow");
                        if(freeShippingThreshold !== "" && freeShippingThreshold === 0) {
                            if(progressBarShowing) {
                                progressBarElWrapper.removeClass("ProgressLSPShow");
                            }
                        }else if(currentCart.total_price !== 0) {
                            if(!progressBarShowing) {
                                progressBarElWrapper.addClass("ProgressLSPShow");
                            }
                        }
                        //Applying progress to bar
                        if(progressBarEl) {
                            progressBarEl.css('width', currentProgressWithPercentage);
                        }
                        var progressBarTextEl = $(this).find('.ProgressLSPText');
                        let progressBarText = lang.freeShippingRemaining;
                        if(progressBarText.includes("{{remaining_amount}}") && currentProgress < 100) {
                            console.log('here 1');
                            if (currentProgress < 100) {
                                progressBarText = progressBarText.replace('{{remaining_amount}}', remainingAmountFormat);
                            }
                        } else if (currentProgress >= 100) {
                            console.log('here 2');
                            console.log('lang.freeShippingReached', lang.freeShippingReached);
                            progressBarText = lang.freeShippingReached;
                        }
                        progressBarTextEl.html(progressBarText);
                        if(currentCountryActiveData.EnabledCountry === "TRUE") {
                            $(this).removeClass("skeletonHidden");
                            $(this).addClass("skeletonShow");
                        }
                    });
                }


        }
    }


      async function startCurrentCartListener(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText) {
        //Listening to cart
        listenCartChange()


        window.addEventListener('SCE:action', (event) => {
            $.getJSON('/cart.js', function (cart) {
                var currentCart = cart;
                insertUSPData(currentCart,currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText);
                updateShippingProgress(currentCart,currentCountryActiveData);
            })
        })
        /*
        var currentCart = await listenCartChange();
        if (currentCart) {
            insertUSPData(currentCart,currentCountryActiveData,currentCountryActiveUspData);
        }
        */
      }


      //Fetching country DATA
      var getCountryData = function (locationData,data) {
        const tableJSON = data.values;
        const keys = Object.keys(tableJSON[0]).map(i => tableJSON[0][i]);

        // JSON Country data
        let countryData = tableJSON.map(obj => {
            const replacedObj = {};
            const oriKeys = Object.keys(obj);
            for (let i = 0; i < keys.length; i++) {
                replacedObj[keys[i]] = obj[oriKeys[i]]
            };
            return replacedObj;
        });

        // JSON USP text data
        var uspAllTextData = [];
        var uspFallbackTextData = "";
        let uspTextDataCount = 0;
        let UPSIndex = null
        let uspData = tableJSON.map((obj,index) => {
            const replacedObj = {};
            const oriKeys = Object.keys(obj);
            if(index == 0){
                for (let j = 0; j < obj.length; j++) {
                    const element = obj[j];
                    if(element == "USP text"){
                        UPSIndex = j
                    }
                }   
            }
            //Fallback for heavy item
            if(index === 11 && index !== 0 ){
                if(obj[UPSIndex]) {
                    uspFallbackTextData = obj[UPSIndex];
                 }
            } else if (obj[UPSIndex] && index !== 0 ){  
                uspAllTextData.push(obj[UPSIndex]);
            }
        });
        //removing undefined
        //let prepaidObjectNew = JSON.parse(JSON.stringify(uspData))
          

        //Country seek

        //Fetch default country
        let fallbackCountry = countryData.filter(function(item){
            return item.CountryCode == "DEFAULT";         
        });
        var fallbackCountryObj = fallbackCountry[Object.keys(fallbackCountry)[0]];

        //Fetch IP country
        var currentCountryCode = locationData;
        
        //Fetch current country
        let currentCountry = countryData.filter(function(item){
            return item.CountryCode == currentCountryCode;         
        });
        var currentCountryObj = currentCountry[Object.keys(currentCountry)[0]];


        //Use default fallback if country is not found in Sheet
        if (currentCountryObj) {

        } else if (fallbackCountryObj) {
            currentCountryObj = fallbackCountryObj;
        } else {
            //Potential editor fallback
            console.log("editor fallback");
        }
        var currentCountryActiveData = {
            "EnabledCountry":  currentCountryObj["Active"],
            "Country":  currentCountryObj["Country"] || fallbackCountryObj["Country"],
            "DeliveryTime": currentCountryObj["Delivery time"] || fallbackCountryObj["Delivery time"],
            "DeliveryTimeHeavy": currentCountryObj["Delivery time heavy"] || fallbackCountryObj["Delivery time heavy"],
            "FreeShippingThreshold": currentCountryObj["Free shipping threshold"] || fallbackCountryObj["Free shipping threshold"],
            "FreeShippingThresholdHeavy": currentCountryObj["Free shipping threshold heavy"] || fallbackCountryObj["Free shipping threshold heavy"],
            "ShippingPrice": currentCountryObj["Shipping price"] || fallbackCountryObj["Shipping price"],
            "ShippingPriceHeavy": currentCountryObj["Shipping price heavy"] || fallbackCountryObj["Shipping price heavy"],
            "USPIcons": window.themeVariables.iconsLSP
        }
        

        //Render USP data
        var currentCountryActiveUspData = getCountryUspData(currentCountryObj,uspAllTextData);
        //Using fallback country if no USP data found for country
        if (currentCountryActiveUspData.length === 0) {
            currentCountryActiveUspData = getCountryUspData(fallbackCountryObj,uspAllTextData);
        }
        var forcedCartUspText = uspAllTextData[4];

        //Assign country name as default country name if data is blank
        /*
        if (currentCountryObj["Delivery time"] && currentCountryObj["Free shipping threshold"] && currentCountryObj["Shipping price"]) {
        } else {
            currentCountryActiveData.Country = fallbackCountryObj["Country"];
        }
        */

        //Saving country data found as localstorage
        // Render
        if(currentCountryActiveData.EnabledCountry === "TRUE") {
            console.log('here');
            renderDataLSP(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText);
        } else {
            console.log('here 2');
            renderDataLSP(currentCountryActiveData,currentCountryActiveUspData,uspFallbackTextData,forcedCartUspText);
            //unsupportedCountryWarning(currentCountryActiveData,currentCountryActiveUspData);
        }
      }

      var unsupportedCountryWarning = function (currentCountryActiveData,currentCountryActiveUspData) {

      }
      var getCountryUspData = function (currentCountryObj,uspAllTextData,uspFallbackTextData) {

        //Finding USP active states for country being parsed
        let currentCountryUspStatus = []
        const currentCountryUspMax = 10;
        let currentCountryUspCount = 0;
        for (let i = 0; i < currentCountryUspMax; i++) {
            currentCountryUspCount = currentCountryUspCount + 1;
            let i = currentCountryUspCount;
            if(currentCountryObj["USP"+ `${currentCountryUspCount}`] !== "TRUE") {
                currentCountryUspStatus.push("FALSE")
            } else {
                currentCountryUspStatus.push(currentCountryObj["USP"+ `${currentCountryUspCount}`]);
            }
        }


        let currentCountryActiveUspData = []
        //mapping available USPS with active USPS
        for (var statusCount = 0; statusCount < currentCountryUspStatus.length; statusCount++) {  
            if(currentCountryUspStatus[statusCount] === "TRUE") {
                for (var textCount = 0; textCount < uspAllTextData.length; textCount++) {
                    if (uspAllTextData[statusCount]) {
                        currentCountryActiveUspData.push(uspAllTextData[statusCount]);
                        break;
                    }
                }
            }
        }
        return currentCountryActiveUspData;
      }


//Listening to any cart API change

async function listenCartChange() {
    (function () {
    if (!window || !window.Shopify) return;
    
    const CartEvents = {
        add: "SCE:action",
        update: "SCE:action",
        change: "SCE:action",
        clear: "SCE:action",
        mutate: "SCE:action",
    };
    //For specfic event listening
    /*
    const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
    };
    */
    const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js",
    ];

    function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
    }

    function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
        return "add";
    } else if (url.includes("cart/update")) {
        return "update";
    } else if (url.includes("cart/change")) {
        return "change";
    } else if (url.includes("cart/clear")) {
        return "clear";
    } else return false;
    }

    function dispatchEvent(url, detail) {
    if (typeof detail === "string") {
        try {
        detail = JSON.parse(detail);
        } catch {}
    }
    //Not needed duplicate
    //window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
    const type = updateType(url);
    switch (type) {
        case "add":
        window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
        break;
        case "update":
        window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
        break;
        case "change":
        window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
        break;
        case "clear":
        window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
        break;
        default:
        break;
    }
    }

    function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
        }
        });
        return originalOpen.apply(this, arguments);
    };
    }

    function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;
    const originalFetch = window.fetch;
    window.fetch = function () {
        const response = originalFetch.apply(this, arguments);

        if (isShopifyCartURL(arguments[0])) {
        response.then((res) => {
            res
            .clone()
            .json()
            .then((data) => dispatchEvent(res.url, data));
        });
        }

        return response;
    };
    }

    fetchOverride();
    XHROverride();
})();
}


//Libs for formatting money

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slateUtils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    },
  
    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
      var i = array.length;
      while(i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
  
      return array;
    },
  
    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   */
  
  slateCurrency = (function () {
    var moneyFormat = '${{amount}}';
  
    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format, useNoDecimals = false) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slateUtils.defaultTo(precision, 2);
        thousands = slateUtils.defaultTo(thousands, ',');
        decimal = slateUtils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      if (useNoDecimals) {
        value = formatWithDelimiters(cents, 0);
      } else {
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    };
  })();
  
  
  /**
   * END Currency Helpers
   */

// Helper to replace [amount] and [country] shortcodes in a string
function replaceShortcodes(str, minOrderAmount, countryName) {
  if (typeof str === 'string') {
    if (str.includes('[amount]') && minOrderAmount) {
      str = str.replace('[amount]', minOrderAmount);
    }
    if (str.includes('[country]') && countryName) {
      str = str.replace('[country]', countryName);
    }
  }
  return str;
}

// Loops through all .LSP-Banner elements and replaces [amount] and [country] in .USP__TextContent spans
function updateLSPBannerAmounts(minOrderAmount, countryName) {
  document.querySelectorAll('.LSP-Banner').forEach(function(banner) {
    banner.querySelectorAll('.USP__TextContent').forEach(function(uspTextContent) {
      uspTextContent.querySelectorAll('span').forEach(function(span) {
        let text = span.textContent.trim();
        if ((text === '[amount]' && minOrderAmount) || (text === '[country]' && countryName) || text.includes('[amount]') || text.includes('[country]')) {
          span.textContent = replaceShortcodes(span.textContent, minOrderAmount, countryName);
        }
      });
    });
  });
}